const initialState = [];

export const videoReducer = function (state = initialState, action) {
    console.log("Action", action);
    switch (action.type) {
        case "ADD_VIDEO":
            return [...state, action.payload];
        case "CLEAR_VIDEOS":
            return [];
        default:
            return state;
    }
};